import {
	FieldInputProps,
	FormikConfig,
	FormikErrors,
	FormikProps,
} from "formik/dist/types";
import { useFormik } from "formik";

interface FormikReturnType<V>
	extends Omit<FormikProps<V>, "setFieldValue" | "getFieldProps"> {
	setFieldValue: (
		field: keyof V,
		value: V[keyof V],
		shouldValidate?: boolean | undefined,
	) => Promise<FormikErrors<V>> | Promise<void>;
	getFieldProps: (key: keyof V) => FieldInputProps<V>;
}

export default function useCustomFormik<InitialValue>({
	...args
}: FormikConfig<InitialValue>): FormikReturnType<InitialValue> {
	const formik = useFormik<InitialValue>(args);

	return {
		...formik,
		setFieldValue: (key, ...args) => formik.setFieldValue(key as string, ...args),
	};
}
